export const tarife = {
  terapie: {
    label: "Terapie",
    servicii: [
      {
        name: "Consultație terapie",
        price: 100,
      },
      {
        name: "Anestezie locală",
        price: 30,
      },
      {
        name: "Obturație MTA",
        price: 150,
      },
      {
        name: "Obturație compozit foto cavitate mică/punctiformă",
        price: 150,
      },
      {
        name: "Obturație compozit foto cavitate medie",
        price: 200,
      },
      {
        name: "Obturație compozit foto cavitate mare",
        price: 250,
      },
      {
        name: "Obturație compozit foto cavitate MOD",
        price: 300,
      },
      {
        name: "Bază glass ionomer (sub obturație foto)",
        price: 50,
      },
      {
        name: "Obturație compozit foto estetică pe dinți frontali",
        price: 300,
      },
      {
        name: "Pansament provizoriu",
        price: 100,
      },
      {
        name: "Aplicare desensibilizant/dinte",
        price: 100,
      },
    ],
  },
  profilaxie: {
    label: "Profilaxie",
    servicii: [
      {
        name: "Igienizare profesională (detartraj+air-flow+periaj profesional)",
        price: 250,
      },
      {
        name: "Detartraj și periaj/dinte",
        price: 25,
      },
      {
        name: "Sigilare șanțuri și fosete/dinte",
        price: 100,
      },
      {
        name: "Fluorizare/aradă",
        price: 100,
      },
      {
        name: "Tratament air-flow/arcadă",
        price: 75,
      },
    ],
  },
  endodontie: {
    label: "Endodontie",
    servicii: [
      { name: "Pansament calmant", price: 150 },
      {
        name: "Urgență (drenaj endo, abces, extirpare mono, pluri)",
        price: 150,
      },
      {
        name: "Tratament de canal monoradicular într-o ședință",
        price: 250,
      },
      {
        name: "Tratament de canal pluriradicular într-o ședință",
        price: 350,
      },
      {
        name: "Tratament de canal pluriradicular într-o ședință molar de minte",
        price: 450,
      },
      {
        name: "Dezobturat per canal",
        price: 100,
      },
      {
        name: "Drenaj endodontic",
        price: 100,
      },
      {
        name: "Retratament de canal monoradicular într-o ședință",
        price: 350,
      },
      {
        name: "Retratament de canal pluriradicular într-o ședință",
        price: 450,
      },
      {
        name: "Retratament de canal pluriradicular într-o ședință molar de minte",
        price: 550,
      },
    ],
  },
  protetica: {
    label: "Protetică",
    servicii: [
      { name: "Coroană acrilică/Măscuță scutan per dinte", price: 150 },
      { name: "Coroană provizorie PMMA CAD-CAM", price: 250 },
      { name: "Coroană provizorie PMMA CAD-CAM pe implant", price: 350 },
      { name: "Coroană metalo-ceramică", price: 600 },
      { name: "Coroană ceramică pe suport zirconiu", price: 1000 },
      { name: "Coroană zirconiu integral", price: 900 },
      { name: "Coroană ceramică presată E-MAX", price: 1300 },
      { name: "Coroană pe implant –metalo-ceramică", price: 1200 },
      {
        name: "Coroană pe implant – zirconiu integral/ceramică pe suport zirconiu",
        price: 1450,
      },
      { name: "Bont personalizat hibrid titan/zirconiu", price: 850 },
      { name: "Inrustație ceramică", price: 1000 },
      { name: "Cimentare/per element", price: 75 },
      { name: "Proteză Kemeny", price: 500 },
      { name: "Proteză totală acrilică", price: 1700 },
      { name: "Proteză parțială acrilică", price: 1700 },
      { name: "Proteză elastică", price: 2500 },
      { name: "Proteză pe capse", price: 2500 },
      { name: "Proteză scheletată", price: 4000 },
      { name: "Reparație proteză", price: 300 },
      { name: "Căptușire proteză", price: 300 },
      { name: "Adăugare dinte proteză", price: 150 },
      { name: "Pivot fibră de sticlă", price: 250 },
      { name: "Pivot metalic Cr-Ni", price: 250 },
      { name: "Pivot Cr-Ni cu clavetă", price: 280 },
      { name: "Pivot zirconiu", price: 600 },
      { name: "Ablație coroană/element", price: 75 },
      { name: "Model de studiu turnat gips/arcadă", price: 75 },
      { name: "Gutieră bruxism", price: 300 },
      { name: "Imobilizare dinți cu fibră de sticlă", price: 700 },
      { name: "Wax-up/mock-up per dinte", price: 150 },
    ],
  },
  esteticaDentara: {
    label: "Estetică dentară",
    servicii: [
      {
        name: "Albire profesională în 1 ședință cu lampă specială",
        price: 1000,
      },
      { name: "Albire per arcadă", price: 600 },
      { name: "Fațetă ceramică E-MAX", price: 1500 },
    ],
  },
  implantologie: {
    label: "Implantologie",
    servicii: [
      { name: "Implant dentar Neodent", price: 2500 },
      { name: "Implant dentar Straumann BLX", price: 3500 },
      { name: "Sistem All on 4 implanturi Neodent", price: 16000 },
      { name: "Sistem All on 6 implanturi Neodent", price: 21000 },
      { name: "Sistem All on 4 implanturi Straumann", price: 20000 },
      { name: "Sistem All on 6 implanturi Straumann", price: 25000 },
    ],
  },
  chirurgie: {
    label: "Chirurgie",
    servicii: [
      { name: "Consultație chirurgie", price: 100 },
      { name: "Extracție dinte monoradicular", price: 150 },
      { name: "Extracție dinte pluriradicular", price: 200 },
      { name: "Extracție dinte parodontotic", price: 100 },
      {
        name: "Extracție rest radicular monoradicular/pluriradicular",
        price: 150,
      },
      { name: "Extracție molar de minte erupt", price: 300 },
      { name: "Extracție prin alveolotomie", price: 300 },
      { name: "Extractie molar de minte partial erupt(ANCLAVAT)", price: 350 },
      { name: "Odontectomie molar de minte/ canin inclus", price: 600 },
      { name: "Germectomie", price: 600 },
      { name: "Inchiderea comunicarii oro-sinusale", price: 300 },
      { name: "Premolarizare", price: 200 },
      { name: "Regularizare osoasa/ hemiarcada", price: 250 },
      { name: "Rezectie apicala monoradicular (cu obturatie)", price: 450 },
      { name: "Rezectie apicala pluriradicular (cu obturatie)", price: 600 },
      { name: "Decapusonare", price: 150 },
      { name: "Incizie și drenaj colectie purulenta", price: 200 },
      { name: "Sutura cu fir resorbabil", price: 30 },
      { name: "Tratament alveolita postextractionala/ sedinta", price: 100 },
      { name: "Chistectomie (1-3 dinti)", price: 400 },
      { name: "Chistectomie (>3 dinti)", price: 600 },
      { name: "Excizie formatiune benigna", price: 500 },
      { name: "Excizie hiperplazie gingivala", price: 300 },
      { name: "Examen anatomo-patologic", price: 200 },
      { name: "Vestibuloplastie/arcada", price: 500 },
      { name: "Frenectomie/ frenoplastie", price: 300 },
      { name: "Gingivectomie/ gingivolastie per dinte", price: 80 },
      {
        name: "Chiuretaj subgingival în camp închis/ dinte (fara biomateriale)",
        price: 100,
      },
      {
        name: "Chiuretaj subgingival în camp deschis / dinte (fara biomateriale)",
        price: 150,
      },
      { name: "Descoperire canin", price: 450 },
      { name: "Sinus lift extern", price: 5000 },
      { name: "Sinus lift intern", price: 2500 },
      { name: "Augmentare osoasa postextractionala (xenogrefa)", price: 2000 },
      { name: "Augmentare osoasa orizontala (BIO-OSS)", price: 2500 },
      { name: "Augmentare osoasa orizontala (os autolog)", price: 3000 },
      { name: "Descoperire implant", price: 100 },
      { name: "Aplicare PRF/PRP", price: 120 },
    ],
  },
  pedodontieCopii: {
    label: "Pedodontie - Stomatologie copii",
    servicii: [
      { name: "Consultație pedodonție", price: 100 },
      { name: "Pansament", price: 100 },
      { name: "Pulpectomie", price: 120 },
      { name: "Obturație canal monoradicular dinte temporar", price: 130 },
      { name: "Obturație canal pluriradicular dinte temporar", price: 150 },
      { name: "Pastă mumifiantă", price: 100 },
      { name: "Extirpare vitală", price: 130 },
      { name: "Drenaj abces", price: 100 },
      { name: "Obturație glassionomer", price: 120 },
      { name: "Obturație compozit foto/dinte cavitate mică", price: 140 },
      { name: "Obturație compozit foto/dinte cavitate medie", price: 190 },
      { name: "Obturație compozit foto/dinte cavitate mare", price: 230 },
      { name: "Coafaj", price: 100 },
      { name: "Extracție dinte de lapte mobil", price: 90 },
      { name: "Extracție dinte de lapte imobil", price: 120 },
      { name: "Sigilare/dinte", price: 100 },
      { name: "Igienizare profesională pedodonție", price: 150 },
      { name: "Fluorizare per arcadă", price: 70 },
      { name: "Fluorizare ambele arcade", price: 120 },
      { name: "Coroană/dinte temporar", price: 500 },
    ],
  },
  ortodontie: {
    label: "Ortodonție",
    servicii: [
      { name: "Consultație ortodonție", price: 100 },
      { name: "Studiu de model", price: 100 },
      { name: "Interpretare dosar ortodontic", price: 200 },
      { name: "Aparat ortodontic fix metalic/arcada", price: 1400 },
      { name: "Aparat ortodontic fix fizionomic/arcada", price: 2700 },
      { name: "Aparat ortodontic fix autoligaturant", price: 2250 },
      { name: "Aparat orto fix Damon/arcada", price: 4500 },
      { name: "Activare aparat fix metalic/arcada", price: 100 },
      { name: "Activare aparat fix fizionomic/arcada", price: 150 },
      { name: "Activare aparat fix Damon", price: 200 },
      { name: "Recolat bracket metalic", price: 100 },
      { name: "Recolat bracket fizionomic", price: 150 },
      { name: "Aparat ortodontic mobilizabil", price: 850 },
      { name: "Reparatie aparat mobil", price: 250 },
      { name: "Disjunctor maxilar", price: 1350 },
      { name: "Distalizator fast back", price: 1350 },
      { name: "Disjunctor cu carlige pentru masca Delaire", price: 1350 },
      { name: "Masca Delaire", price: 700 },
      { name: "Arc lingual", price: 600 },
      { name: "Lup bumper", price: 550 },
      { name: "Arc transpalatar", price: 550 },
      { name: "Quad-helix", price: 550 },
      { name: "Aparat de contentie Hawley", price: 450 },
      { name: "Mentinator de spatiu monodentar", price: 250 },
      { name: "Indepartare aparat fix metalic/arcada", price: 100 },
      { name: "Indepartare aparat fix fizionomic/arcada", price: 200 },
      { name: "Gutiera de contentie termoformata", price: 450 },
      { name: "Contentie fixa", price: 250 },
      { name: "Ancoraj scheletal cu mini-implant ortodontic", price: 700 },
      { name: "Disjunctor/distalizator pe mini-implante", price: 4500 },
      {
        name: "Tratament ortodontic cu alignere SPARK, 10 gutiere",
        price: 9000,
      },
      {
        name: "Tratament ortodontic cu alignere SPARK, 20 gutiere",
        price: 18000,
      },
      {
        name: "Tratament ortodontic cu alignere SPARK, gutiere nelimitate",
        price: 27000,
      },
      { name: "Tratament cu gutiere/arcada", price: 2700 },
      { name: "Splint articular", price: 1350 },
    ],
  },
};
